var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 20.0003H17.3333V22.667H14.6666V20.0003ZM14.6666 9.33366H17.3333V17.3337H14.6666V9.33366ZM15.9866 2.66699C8.62663 2.66699 2.66663 8.64033 2.66663 16.0003C2.66663 23.3603 8.62663 29.3337 15.9866 29.3337C23.36 29.3337 29.3333 23.3603 29.3333 16.0003C29.3333 8.64033 23.36 2.66699 15.9866 2.66699ZM16 26.667C10.1066 26.667 5.33329 21.8937 5.33329 16.0003C5.33329 10.107 10.1066 5.33366 16 5.33366C21.8933 5.33366 26.6666 10.107 26.6666 16.0003C26.6666 21.8937 21.8933 26.667 16 26.667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.486bd12c7980d4b7fc9c39fe859272e1.svg";
export { ForwardRef as ReactComponent };